import { render, staticRenderFns } from "./UPSMonitoring.vue?vue&type=template&id=ee4bdb6c&scoped=true"
import script from "./UPSMonitoring.vue?vue&type=script&lang=js"
export * from "./UPSMonitoring.vue?vue&type=script&lang=js"
import style0 from "./UPSMonitoring.vue?vue&type=style&index=0&id=ee4bdb6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee4bdb6c",
  null
  
)

export default component.exports